const ANIM_DURATION = 280;
const ANIM_EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

function animateDetails(details) {
  if (details.dataset.animating === 'true') return;

  const summary = details.querySelector('summary');
  if (!summary) return;

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    if (details.dataset.animating === 'true') return;
    details.dataset.animating = 'true';

    if (details.open) {
      closeDetails(details);
    } else {
      openDetails(details);
    }
  });
}

function openDetails(details) {
  details.style.overflow = 'hidden';
  details.open = true;

  const startHeight = `${details.querySelector('summary').offsetHeight}px`;
  const endHeight = `${details.scrollHeight}px`;

  const anim = details.animate(
    { height: [startHeight, endHeight] },
    { duration: ANIM_DURATION, easing: ANIM_EASING }
  );

  anim.onfinish = () => finishAnimation(details);
}

function closeDetails(details) {
  details.style.overflow = 'hidden';

  const startHeight = `${details.offsetHeight}px`;
  const endHeight = `${details.querySelector('summary').offsetHeight}px`;

  const anim = details.animate(
    { height: [startHeight, endHeight] },
    { duration: ANIM_DURATION, easing: ANIM_EASING }
  );

  anim.onfinish = () => {
    details.open = false;
    finishAnimation(details);
  };
}

function finishAnimation(details) {
  details.style.overflow = '';
  details.style.height = '';
  details.dataset.animating = 'false';
}

export function initDetailsAnimate(selector = '.lv-details') {
  document.querySelectorAll(selector).forEach(animateDetails);
}